import { type FC } from "react";
import { type GuidanceBoxProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import { PcView } from "./uiParts/PcView";
import { SpView } from "./uiParts/SpView";

export const GuidanceBox: FC<GuidanceBoxProps> = ({ isSp }) => {
  // TODO: InfomationCardコンポーネントを適用すれば分岐を削除できる可能性があるので検討してください。
  return <>{isSp ? <SpView /> : <PcView />}</>;
};
